import { useMemo } from 'react'
import type { Divisao } from '../api'
import { ordenarDivisoes } from '../cartao'
import { CardMarca } from './CardMarca'

/**
 * A grade das divisões — 4 × 2 no telão, 3, 2 e 1 coluna conforme a largura
 * (as media queries já estão em `estilos/dashboard.css`).
 *
 * São 8 hoje, mas o número NÃO é fixo: a grade percorre o que vem do cadastro,
 * então divisão nova cadastrada no admin aparece sem tocar em código.
 */

type Props = {
  divisoes: Divisao[]
  aoAbrirMarca: (id: string) => void
  /** Ids que acabaram de mudar de valor: ligam o realce de 1 s no card. */
  mudaram: Set<string>
}

export function GradeMarcas({ divisoes, aoAbrirMarca, mudaram }: Props) {
  /* A ordem é a do cadastro. `useMemo` porque o array chega novo a cada
     snapshot, e reordenar a cada tique do relógio do cabeçalho é trabalho
     jogado fora. */
  const ordenadas = useMemo(() => ordenarDivisoes(divisoes), [divisoes])

  /* Cadastro vazio (banco novo, antes do semear) não pode virar um vão escuro
     embaixo do número herói. Reaproveita `.carregando`, que é o mesmo slot
     `flex:1` centrado — nenhuma classe nova. */
  if (ordenadas.length === 0) {
    return <div className="carregando">Nenhuma divisão cadastrada</div>
  }

  /* Sem `memo` aqui de propósito: o `Set` de mudanças troca de identidade a cada
     repintura do Dashboard, então um `memo` raso nunca pegaria. Quem corta
     trabalho é o `memo` do card, que recebe só o booleano `piscar`. */
  return (
    <section className="marcas">
      {ordenadas.map(divisao => (
        <CardMarca
          key={divisao.id}
          divisao={divisao}
          aoClicar={aoAbrirMarca}
          piscar={mudaram.has(divisao.id)}
        />
      ))}
    </section>
  )
}
